"use strict";
const _ = require('lodash');
const getInviteWhere = (shopConfig, email) => {
    const emailToLowerCase = email.toLowerCase();
    const usesSupplierCustomer = _.get(shopConfig, 'usesSupplierCustomer');
    return usesSupplierCustomer
        ? {
            where: {
                email: emailToLowerCase,
                shopConfig,
            },
        }
        : {
            where: {
                email: emailToLowerCase,
                shopConfig: { usesSupplierCustomer: false },
            },
        };
};
module.exports = { getInviteWhere };
